export default "__VITE_ASSET__7xNIKM9R__"